import MarqueeCarouselImage from "@/assets/images/marquee-carousel-1.png";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import Amplitude from "@/shared/services/amplitude.service";
import { SuccessStoryType } from "@/shared/types/common.types";
import {
  getCurrentURL,
  getReferrer,
  getScreenWidth,
} from "@/shared/utils/commons";
import { getUTMFieldsFromLocalStorage } from "@/shared/utils/utm.util";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

const SuccessStoryGridCard = ({
  successStory,
  index,
}: {
  successStory: SuccessStoryType;
  index: string | number;
}) => {
  const actionCreatorStoryClick = () => {
    const {
      current_url,
      screen_width,
      referrer,
      utm_params,
      creator_name,
      creator_domain,
      creator_category,
      index,
    } = LANDING_PAGE_EVENTS.CREATOR_WEBSITE_TAPPED.PROPERTIES;

    new Amplitude().sendEvent({
      type: LANDING_PAGE_EVENTS.CREATOR_WEBSITE_TAPPED.LABEL,
      properties: {
        [current_url]: getCurrentURL(),
        [screen_width]: getScreenWidth(),
        [referrer]: getReferrer(),
        [utm_params]: getUTMFieldsFromLocalStorage(),
        [creator_name]: successStory.name,
        [creator_domain]: successStory.href,
        [creator_category]: successStory.category,
        [index]: index,
      } as { [key: string]: string },
    });
  };
  return (
    <Link
      href={successStory.href}
      target="_blank"
      rel="nofollow"
      className={classNames(`group/card pointer-events-none`)}
      onClick={actionCreatorStoryClick}
    >
      <div
        className={classNames(
          "pointer-events-auto relative flex cursor-pointer flex-col bg-grey-1 transition group-hover/card:bg-purple-0",
          {
            "rounded-b-xl rounded-t-xl group-hover/card:rounded-t-none": true,
          }
        )}
      >
        <div
          className={classNames("overflow-hidden", {
            "bottom-0 origin-bottom rounded-t-xl group-hover/card:bottom-full":
              true,
          })}
        >
          <Image
            src={successStory.image || MarqueeCarouselImage}
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: "100%", height: "auto" }}
            alt={`${successStory.name}'s website`}
          />
        </div>
        <div className={`flex flex-col gap-3 px-3 pb-4 pt-3`}>
          <div className="flex items-center gap-2">
            <div className="relative h-9 w-9 overflow-hidden rounded-full bg-grey-4">
              <Image
                src={successStory.avatar || MarqueeCarouselImage}
                fill
                style={{
                  objectFit: "cover",
                }}
                alt={`${successStory.name}'s avatar`}
              />
            </div>
            <div className="flex flex-1 flex-col">
              <h4 className="text-title-14 text-grey-4">{successStory.name}</h4>
              <p className="text-body-10 text-grey-4">
                {successStory.designation} | {successStory.company}
              </p>
            </div>
            <div className="flex flex-col text-right">
              <p className="text-title-12 text-purple-3">
                {successStory.highlight.main}
              </p>
              <p className="text-body-10 text-grey-4">
                {successStory.highlight.subtext}
              </p>
            </div>
          </div>
          <p className="text-body-12 text-grey-4">{successStory.description}</p>
        </div>
      </div>
    </Link>
  );
};

export default SuccessStoryGridCard;
